// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"edca44db","977":"ef4a6215"}[chunkId] + ".chunk.js";
};